import tw, { css, styled } from 'twin.macro';
import * as Yup from 'yup';
import required from 'core/assets/images/required.svg';

export const ItemName = styled.span<{ isRequired?: boolean }>`
  ${tw`text-[12px] font-bold text-[#333333]`};

  ${tw`self-start`}

  ${tw`relative pr-[9px]`}

  ${({ isRequired }) =>
    isRequired &&
    `&:after{content:'';background-image:url(${required.src});background-size:5px 5px;width:5px;height:5px;}`}

	${tw`after:top-[3px] after:right-0 after:absolute`}
`;

export const ModifyButton = styled.button`
  ${tw`rounded-[4px] bg-[#666] text-white text-[14px] p-[8px]`}
`;

export const DescMsg = styled.p`
  ${tw`mt-[8px] text-[12px] text-[#666] empty:mt-[0]`};
`;

export const ErrorMsg = styled.p`
  ${tw`mt-[8px] text-[12px] text-[#ff223d] empty:mt-[0]`};
`;

export const SuccessMsg = styled.p`
  ${tw`mt-[8px] text-[12px] text-[var(--main-color)] empty:mt-[0]`};
`;

const safariSelectReset = css`
  ${`
	appearance: none;
	line-height: normal;
	position: relative;
	background-position: right 10px top 50%;
	background-repeat: no-repeat;
	background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBjbGFzcz0iY3NzLWNjZHZncCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTYgMHYxNkgwVjB6Ij48L3BhdGg+PHBhdGggZD0iTTEzLjI5NSA0LjcwNWEuOTk4Ljk5OCAwIDAgMC0xLjQxIDBMOCA4LjU4IDQuMTE2IDQuNzA0YS45OTguOTk4IDAgMCAwLTEuNDExIDEuNDExbDQuNTg4IDQuNTg4YTEgMSAwIDAgMCAxLjQxNCAwbDQuNTg4LTQuNTg4YS45OTcuOTk3IDAgMCAwIDAtMS40MXoiIGZpbGw9IiM5OTkiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPjwvZz48L3N2Zz4=)
`}
`;

const safariInputSelectReset = css`
  ${`webkit-appearance: none;
  -webkit-border-radius: 0;
`}
`;

export const inputStyle = css`
  ${tw`bg-[#fff] text-[#000]`};

  ${tw`text-[14px]`};
  ${tw`py-[8px]`};
  ${tw`w-full sm:w-[340px]`};

  ${tw`border-[#ccc] border-b-[1px]`};
  ${tw`outline-none`};

  &:focus {
    ${tw`border-[var(--main-color)] border-b-[1px]`};
  }

  &::placeholder {
    ${tw`text-[#ccc]`};
  }

  ${safariInputSelectReset};
`;

export const inputStyleReadOnly = css`
  ${tw`bg-[#f5f5f5] text-[#999]`};
  ${tw`border-[#ccc] border-b-[1px]`};
  ${tw`text-[14px]`};
  ${tw`py-[7px]`};
  ${tw`sm:w-[340px]`};

  ${tw`outline-none`};

  ${safariInputSelectReset};
`;

export const selectStyle = css`
  ${tw`bg-[#fff] text-[#000]`};
  ${tw`border-[#ccc] border-b-[1px]`};
  ${tw`text-[14px]`};
  ${tw`py-[8px]`};
  /* ${tw`w-[340px]`}; */

  ${tw`border-[#ccc] border-b-[1px]`};
  ${tw`outline-none`}
  &:focus {
    ${tw`border-[var(--main-color)] border-b-[1px]`}
  }

  ${safariInputSelectReset};
  ${safariSelectReset};
`;

export const checkToogleStyle = css`
  ${tw`relative cursor-pointer`};
  > div {
    ${tw`w-[50px] h-[30px] rounded-full inline-block`};
    ${tw`bg-[#ccc]`};
  }

  span {
    ${tw`w-[28px] h-[28px] rounded-full inline-block`};
    ${tw`bg-white`};
    ${tw`m-[1px]`};
    ${tw`transition-transform`};
  }

  input {
    ${tw`absolute top-0 left-0 opacity-0`};
  }

  input:checked + div {
    ${tw`bg-[#6699ff]`};
  }

  input:checked + div span {
    ${tw`translate-x-[20px]`};
  }
`;

export const SubmitButton = styled.button`
  ${tw`bg-[var(--main-color)] rounded-[4px] h-[44px]`};
  ${tw`mt-[20px]`};
  ${tw`text-[16px] font-bold text-white w-full`};
  ${tw`disabled:bg-[#888]`};
`;

export const emailRegex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,7}))$/,
);
export const passwordRegex = new RegExp(
  /(^(?=.*\d)(?=.*[A-Za-z])|^(?=.*[!@#$%^&*])(?=.*[A-Za-z])|^(?=.*[!@#$%^&*])(?=.*\d))[\da-zA-Z!@#$%^&*]{6,20}$/,
);

export const corporateRegistrationNumberRegex = new RegExp(
  /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})$/,
);
export const phoneRegex = new RegExp(/^(\d{2,3})-(\d{3,4})-(\d{3,4})$/);
export const nameRegex = new RegExp(/^[가-힣a-zA-Z]+$/);

export const emailFrontRegex = new RegExp(/^[\w]+$/);

export const Header = styled.header`
  ${tw`text-[24px] font-bold text-[#333]`}
  ${tw`text-center`}
`;

export const schema = {
  loginId: Yup.string()
    .required('필수값입니다.')
    .matches(phoneRegex, '휴대폰번호를 정확히 입력해주세요.'),
  loginPw: Yup.string()
    .required('필수값입니다.')
    .matches(
      passwordRegex,
      '비밀번호는 숫자와 영문자, 특수문자 중 2개이상 조합으로 6~20자리를 사용해야 합니다.',
    ),
  loginPw1: Yup.string()
    .oneOf([Yup.ref('loginPw'), null], '비밀번호가 일치하지 않습니다.')
    .required('필수값입니다.'),
};

const standardPhone = '1';
const standardSeoul = '2';

// only phonenumber
export const phoneFormatter = (value: string): string => {
  if (value.length > 13) return value;
  if (value[1] === standardPhone)
    return value.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');

  // if (value[1] === standardSeoul)
  //   return value.replace(/(\d{2})(\d{3})(\d+)/, '$1-$2-$3');

  return value.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
};

export const Checkbox = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.884766"
        width="23"
        height="23"
        rx="11.5"
        fill="#fff"
        stroke="#DDDDDD"
      />
      <path
        d="M7 13.0598L10.8125 16.3848L17 9.38477"
        stroke="#DDDDDD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckboxSpan = styled.span<{
  isRequired?: boolean;
  isUnderline?: boolean;
}>`
  ${tw`text-[14px] text-[#666]`};

  ${tw`self-start`}

  ${tw`relative pr-[9px]`}

  ${({ isRequired }) =>
    isRequired &&
    `&:after{content:'';background-image:url(${required.src});background-size:5px 5px;width:5px;height:5px; position: absolute}`}

  ${({ isUnderline }) => isUnderline && tw`underline`}

	${tw`after:top-[7px] after:right-0 after:absolute`}
`;

export const checkStyle = css`
  ${[tw`relative flex items-center cursor-pointer`, tw`font-weight[800]`]}
  input {
    ${tw`absolute top-0 left-0 opacity-0`}
  }

  input:checked ~ span {
    ${tw`text-[#333]`}
  }

  input:checked + svg {
    rect {
      fill: #5b809b;
    }
    path {
      stroke: #fff;
    }
  }

  svg {
    margin-right: 8px;
  }
`;
